import React from "react";
import styled from "styled-components";
import { ButtonInput, Container, Logo } from "./reusable_components";
import { NavList, UserSectionList } from "../data";
import { Link } from "react-router-dom";
import { auth } from "../firebase_config";

const NavbarCSS = styled.div`
  width: 100%;
  height: 113px;
  background-color: #1a0b2e;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const LogoSection = styled.div`
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 480px) {
    display: none;
  }
`;
const NavSection = styled.div`
  width: 40%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  @media (max-width: 480px) {
    width: 60%;
  }
`;
const UserSection = styled.div`
  width: 30%;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;


const Navbar = () => {
  const handleLogOut = () => {
    try {
      auth.signOut();
      window.location.replace("/");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <Container>
        <NavbarCSS>
          <LogoSection>
            <Logo />
          </LogoSection>
          <NavSection>
            {NavList.map((i, index) => (
              <ListItem data={i} key={index} />
            ))}
            {auth.currentUser?.email === "abc@gmail.com" && (
              <ListItem data={{ routeName: "admin", routePath: "/admin" }} />
            )}
            
          </NavSection>

          {auth.currentUser ? (
            <ButtonInput value="LogOut" onClick={handleLogOut} />
          ) : (
            <UserSection>
              {UserSectionList.map((i, index) => (
                <ListItem data={i} key={index} />
              ))}
            </UserSection>
          )}
        </NavbarCSS>
      </Container>
    </>
  );
};

const ListItemCSS = styled.span`
  width: auto;
  height: auto;

  color: #fff;
  font-weight: 500;
  font-family: "Preahvihear", sans-serif;
  letter-spacing: 2%;
  @media (max-width: 480px) {
    font-size: 10px;
  }
`;

const ListItem = ({ data }) => {
  return (
    <>
      <ListItemCSS>
        <Link to={data.routePath}>{data.routeName}</Link>
      </ListItemCSS>
    </>
  );
};
export default Navbar;
